import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=2d01f1dc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=2d01f1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01f1dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d01f1dc')) {
      api.createRecord('2d01f1dc', component.options)
    } else {
      api.reload('2d01f1dc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=2d01f1dc&scoped=true&", function () {
      api.rerender('2d01f1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X5VA6L14AIik/JS/comp/PopupDialog.vue"
export default component.exports